import Vue from 'vue'
import Vuex from 'vuex'
import module from './modules/module'
import products from './modules/products'
import orders from './modules/orders'
import orderStatuses from './modules/orderStatuses'
import itemsSelected from './panel/itemsSelected'
import sendProducts from './panel/sendProducts'
import sendAnnouncements from './panel/sendAnnouncements'
import editAnnouncement from './panel/editAnnouncement'
import productsMarketplace from './modules/productsMarketplace'
import mercadoLivreAccounts from './modules/mercadoLivreAccounts'
import mercadoLivreSizeGrid from './modules/mercadoLivreSizeGrid'
import shopeeAccounts from './modules/shopeeAccounts'
import amazonAccounts from './modules/amazonAccounts'
import tikTokShopAccounts from './modules/tikTokShopAccounts'
import sheinAccounts from './modules/sheinAccounts'
import magaluAccounts from './modules/magaluAccounts'
import mercadoLivreAnnouncementsMigration from './modules/mercadoLivreAnnouncementsMigration'
import productMigration from './modules/productMigration'
import user from './modules/user'
import brands from './modules/brands'
import sizes from './modules/sizes'
import flavors from './modules/flavors'
import colors from './modules/colors'
import logs from './modules/logs'
import presets from './modules/presets'
import toolBatchTask from './modules/toolBatchTask'
import toolApi from './modules/toolApi'
import feed from './modules/feed'
import marketplaceAttribute from './modules/marketplaceAttribute'
import marketplaceBrands from './modules/marketplaceBrands'
import errors from './panel/errors'
import editPrices from './panel/editPrices'

import { getField, updateField } from 'vuex-map-fields'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    module,
    products,
    orders,
    orderStatuses,
    itemsSelected,
    sendProducts,
    sendAnnouncements,
    editAnnouncement,
    productsMarketplace,
    user,
    errors,
    brands,
    sizes,
    flavors,
    colors,
    mercadoLivreAccounts,
    mercadoLivreSizeGrid,
    mercadoLivreAnnouncementsMigration,
    productMigration,
    shopeeAccounts,
    amazonAccounts,
    tikTokShopAccounts,
    sheinAccounts,
    magaluAccounts,
    logs,
    presets,
    toolBatchTask,
    toolApi,
    feed,
    marketplaceAttribute,
    editPrices,
    marketplaceBrands
  },
  getters: {
    getField
  },
  mutations: {
    updateField
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js